export const VERIFY_TOKEN_STARTED = "VERIFY_TOKEN_STARTED";
export const VERIFY_TOKEN_END = "VERIFY_TOKEN_END";

export const USER_LOGIN_STARTED = "USER_LOGIN_STARTED";
export const USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE";

export const VERIFY_USER_SUCCESS = "VERIFY_USER_SUCCESS";
export const USER_LOGOUT = "USER_LOGOUT";

// SETTINGS CONSTANTS
export const SIDEBAR_BG = "SIDEBAR_BG";
export const THEME = "THEME";
export const DIRECTION = "DIRECTION";

// THANKYOU CONSTANTS
export const LOGIN_CUSTOMER_AFTER_REGISTER = "LOGIN_CUSTOMER_AFTER_REGISTER";

export const FAMILY_PLANS = {
  3: {
    originalPrice: 465,
    promotionPrice: 295,
    discount: "37%",
    monthlyCost: 24.99,
  },
  4: {
    originalPrice: 620,
    promotionPrice: 384,
    discount: "38%",
    monthlyCost: 31.99,
  },
  5: {
    originalPrice: 775,
    promotionPrice: 450,
    discount: "42%",
    monthlyCost: 37.99,
  },
  6: {
    originalPrice: 930,
    promotionPrice: 540,
    discount: "42%",
    monthlyCost: 45.99,
  },
  7: {
    originalPrice: 1085,
    promotionPrice: 630,
    discount: "42%",
    monthlyCost: 52.99,
  },
  8: {
    originalPrice: 1240,
    promotionPrice: 720,
    discount: "42%",
    monthlyCost: 59.99,
  },
  9: {
    originalPrice: 1395,
    promotionPrice: 810,
    discount: "42%",
    monthlyCost: 67.99,
  },
  10: {
    originalPrice: 1550,
    promotionPrice: 900,
    discount: "42%",
    monthlyCost: 74.99,
  },
};

const dev =
  process.env.REACT_APP_SERVER_ENV === "development" ||
  process.env.REACT_APP_SERVER_ENV === "local";

export const PUBLIC_KEY = dev
  ? "pk_test_51Ie1dpGLa25NHdnwNkxShaUtKe6P0oxMKVCeR1GZYiexLpKlzbkdebjfvqJ6qyWxeElz5GGqgfagUELonfNB4zpL007N8sy08l"
  : "pk_live_51Ie1dpGLa25NHdnwdN6qYzQRob6UvFZnotT9zE0PQeCePRBxXhvrXsFAdkLSr9WkJ520wdVJHaVpa0KwF8XkTmCh00bmShPcoN";

export const STRIPE = {
  SOLO: {
    ID: dev ? "prod_Jd0BOtKHJaRbDp" : "prod_Je2IR7MZ1tw9ps",
    YEAR_ID: dev
      ? "price_1MUntdGLa25NHdnwvG6YN5g4"
      : "price_1MVpx7GLa25NHdnwHgqDJJex",
    MONTH_ID: dev
      ? "price_1J50BQGLa25NHdnwvqrBgBbm"
      : "price_1J0kDUGLa25NHdnwddahBdhv",
    originalPrice: 155,
    promotionPrice: 120,
    discount: "23%",
    monthlyCost: 9.99,
    ndcrRate: 9.99,
  },
  DOUBLE: {
    ID: dev ? "prod_Jd0D8UPc22gLFa" : "prod_Je2HkPFgGlSeCk",
    YEAR_ID: dev
      ? "price_1MUntdGLa25NHdnwOUxryZ4F"
      : "price_1MVpx7GLa25NHdnwgRDz05XD",
    MONTH_ID: dev
      ? "price_1J50CWGLa25NHdnwcbGq4VQ9"
      : "price_1J0kDPGLa25NHdnwtXwI9qzP",
    originalPrice: 310,
    promotionPrice: 204,
    discount: "34%",
    monthlyCost: 16.99,
    ndcrRate: 15.99,
  },
  FAMILY: {
    ID: dev ? "prod_Jd0Ee61lc0dxj1" : "prod_Je2HXhMs7LxHva",
    YEAR_ID: dev
      ? "price_1IzkETGLa25NHdnwWKPIvhvk"
      : "price_1J0kDJGLa25NHdnw5WW4Ij1t",
    MONTH_ID: dev
      ? "price_1IzkE8GLa25NHdnwZYq1McJi"
      : "price_1J0kDJGLa25NHdnwwku4MWoQ",
    YEARLY_PLANS: {
      3: dev
        ? "price_1MUntdGLa25NHdnwOFlCtpvx"
        : "price_1MVpx7GLa25NHdnwzcRzXFd8",
      4: dev
        ? "price_1MUntdGLa25NHdnwOuFEFAa9"
        : "price_1MVpx7GLa25NHdnwjXplnwEt",
      5: dev
        ? "price_1MUntdGLa25NHdnwzeSlLtM6"
        : "price_1MVpx7GLa25NHdnwCII4VqVf",
      6: dev
        ? "price_1MUntdGLa25NHdnwdgYbPTZa"
        : "price_1MVpx7GLa25NHdnwZsjbflhF",
      7: dev
        ? "price_1MUntdGLa25NHdnwariaNJQD"
        : "price_1MVpx7GLa25NHdnwAAT6Vydv",
      8: dev
        ? "price_1MUntdGLa25NHdnwVIq0dCHp"
        : "price_1MVpx7GLa25NHdnwBPkRnPU9",
      9: dev
        ? "price_1MUntdGLa25NHdnw3TrUNjMV"
        : "price_1MVpx7GLa25NHdnwa6pBsYN2",
      10: dev
        ? "price_1MUntdGLa25NHdnw40s6a9Uq"
        : "price_1MVpx7GLa25NHdnweUExy4cQ",
    },
  },
  REPUTATION_STANDARD: {
    YEAR_ID: dev
      ? "price_1Mp8IGGLa25NHdnwfcUhocUW"
      : "price_1MrZcPGLa25NHdnw9rqZzc2h",
    MONTH_ID: dev
      ? "price_1Mq9LkGLa25NHdnwTSNnVItP"
      : "price_1MrZdWGLa25NHdnwjmElFz5G",
  },
  REPUTATION_PLUS: {
    YEAR_ID: dev
      ? "price_1Mp8IxGLa25NHdnw24FSSohB"
      : "price_1MrZcjGLa25NHdnwHa09hF6D",
    MONTH_ID: dev
      ? "price_1Mq9MGGLa25NHdnwUzFjBnTU"
      : "price_1MrZdjGLa25NHdnwWU0vawjU",
  },
  REPUTATION_VIP: {
    YEAR_ID: dev
      ? "price_1Mp8JmGLa25NHdnwi6RGj2tR"
      : "price_1MrZcxGLa25NHdnwSzoWYan8",
    MONTH_ID: dev
      ? "price_1Mq9MmGLa25NHdnwnVsQjwzq"
      : "price_1MrZdwGLa25NHdnw8tZj8Z2r",
  },
  REPUTATION_VIPELITE: {
    YEAR_ID: dev
      ? "price_1Mp8KTGLa25NHdnwUv1ZZb4p"
      : "price_1MrZdEGLa25NHdnwl6hUvzu9",
    MONTH_ID: dev
      ? "price_1Mq9NXGLa25NHdnw9i9aGESv"
      : "price_1MrZe8GLa25NHdnwxupR4El2",
  },
};

export const PAYPAL_TRIAL = {
  CLIENT_ID: dev
    ? "AZZlmumgwaGMyMM71cmQpliWxPaVsSBgvPKklrFqttbXHQzxH7UCVGz50K5h4Hmyd1HYPmrxkHZqKx0G"
    : "AeS1wH0sJVGxvHGkVrMYCkyJWpLe6RFxgEXymXoPpyzUj9Tm_6pv8y9zdu-cvpLiihSlmkjW88cDmoov",
  SOLO: {
    ID: dev ? "0PR59393H47294438" : "3WE1700159599202P",
    YEAR_ID: dev ? "P-4CM11228B6072780TMIKLF7I" : "P-47P6711437935930CMGO5Y4A",
    MONTH_ID: dev ? "P-81529771NK229884XMIKIKWI" : "P-2SY259359J4381424MFFQJBY",
  },
  DOUBLE: {
    ID: dev ? "0C760429J6351550N" : "5XD63260BT235793F",
    YEAR_ID: dev ? "P-4BS038150A0588205MIKLICY" : "P-08G79421NL8189159MGO52XY",
    MONTH_ID: dev ? "P-2XL62984HB478762VMIKLHLY" : "P-69P50884CK717921WMFFQJTI",
  },
  FAMILY: {
    ID: dev ? "6PH037017M410193L" : "4FC83479B87653034",
    YEAR_ID: dev ? "P-4S2079559E390093RMIKLJIA" : "P-08H42847GV396005JMGO5VOI",
    MONTH_ID: dev ? "P-4JU84357UB162081MMIKLI4Y" : "P-6YA44410V4393200EMFFQN2Q",
  },
};

export const PAYPAL = {
  CLIENT_ID: dev
    ? "AZZlmumgwaGMyMM71cmQpliWxPaVsSBgvPKklrFqttbXHQzxH7UCVGz50K5h4Hmyd1HYPmrxkHZqKx0G"
    : "AeS1wH0sJVGxvHGkVrMYCkyJWpLe6RFxgEXymXoPpyzUj9Tm_6pv8y9zdu-cvpLiihSlmkjW88cDmoov",
  SOLO: {
    ID: dev ? "0PR59393H47294438" : "3WE1700159599202P",
    YEAR_ID: dev ? "P-38E0032773207064KMPJZPFY" : "P-9AW23794B36855314MPLVI2Q",
    MONTH_ID: dev ? "P-6A544363PA1283814MHHND2Q" : "P-6JC516175H0938606MIKLQ7Q",
  },
  DOUBLE: {
    ID: dev ? "0C760429J6351550N" : "5XD63260BT235793F",
    YEAR_ID: dev ? "P-9DY88258KY321074SMPJZPOQ" : "P-11G949562S892070GMPLVJCA",
    MONTH_ID: dev ? "P-9UV62733B74058148MHHNFVA" : "P-9D5217451Y744671VMIKLRUQ",
  },
  FAMILY: {
    ID: dev ? "6PH037017M410193L" : "4FC83479B87653034",
    YEAR_ID: dev ? "P-1LF67424B61024212MGK77HY" : "P-5AT53157TE5189647MGO5X7Y",
    MONTH_ID: dev ? "P-8VW18140J9103384SMHHNGSY" : "P-6HH62180MA4020545MIKLSRQ",
    YEARLY_PLANS: {
      3: dev ? "P-79Y394870S4373526MPJZPZA" : "P-1HH2287410452962LMPLVJJA",
      4: dev ? "P-61R66834Y2192874AMPJZQAQ" : "P-8WK52848C24136649MPLVJQA",
      5: dev ? "P-6WH79335NF570214FMPJZQJQ" : "P-8L330555U6828210MMPLVJWY",
      6: dev ? "P-95S97728L9446352NMPJZRDA" : "P-52B35879GN607225PMPLVJ4Y",
      7: dev ? "P-0B8272440M5274822MPJZRKY" : "P-0E572277MU653262VMPLVKCQ",
      8: dev ? "P-791912891X7968545MPJZRZI" : "P-3MX729038P414044WMPLVKII",
      9: dev ? "P-80646904VV478754BMPJZSIY" : "P-3BH16282LH999070CMPLVKQI",
      10: dev ? "P-1J375964G2090941KMPJZS7I" : "P-8A4234149H1528614MPLVKYQ",
    },
  },
  REPUTATION_STANDARD: {
    YEAR_ID: dev ? "P-70907090DJ070902TMQQT35Y" : "P-6WN80497MF2818444MQSYTVQ",
    MONTH_ID: dev ? "P-752004243F214974YMQQT5AQ" : "P-1SX82048TA533690KMQSYUAI",
  },
  REPUTATION_PLUS: {
    YEAR_ID: dev ? "P-17928026FX829432NMQQT4HQ" : "P-7SY62313350747305MQSYULA",
    MONTH_ID: dev ? "P-07296304KE425890GMQQT5IA" : "P-9FP33492M0832994UMQSYURI",
  },
  REPUTATION_VIP: {
    YEAR_ID: dev ? "P-3LD272647E214853UMQQT4QA" : "P-31F22209LA573463RMQSYUZY",
    MONTH_ID: dev ? "P-9U850632K8768653FMQQT5OY" : "P-0CJ36558ES704002TMQSYVCI",
  },
  REPUTATION_VIPELITE: {
    YEAR_ID: dev ? "P-2R745253VB483170RMQQT4ZI" : "P-6N127396PY107592CMQSYVOA",
    MONTH_ID: dev ? "P-3UW80087XM1476924MQQT5VQ" : "P-9LV013576U483394MMQSYVVY",
  },
};

export const FREE_REPUTATION_CONSULTATION_URL =
  "https://reputationmanagement.deletemyinfo.com/appointment";

export const frontendURL = dev
  ? "https://dev-customer.deletemyinfo.com"
  : "https://customer.deletemyinfo.com";
